import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperImageRolloverSlider() {

    const selector = ".image-rollover-slider__swiper";
    const swiperEls = document.querySelectorAll(selector);
    if (!swiperEls.length) return;

    swiperEls.forEach((el) => {
        const root = el.closest('.image-rollover-slider');
        if (!root) return;

        const slidesPerView = Number(root.dataset.slidesPerView) || 2.8;
        const autoplay = root.dataset.autoplay === 'true';
        
        const options = {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            speed: 700,
            slidesPerView,
            spaceBetween: 20,
            watchSlidesProgress: true,
            preloadImages: true,
            pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true,
            },
        };

        if (autoplay) {
            options.autoplay = {
                delay: 5000,
                disableOnInteraction: false,
            };
        }

        // Breakpoints
        options.breakpoints = {
            0: {
                slidesPerView: Number(root.dataset.slidesPerViewPhone) || 1.2,
            },
            768: {
                slidesPerView: Number(root.dataset.slidesPerViewTablet) || 1.8,
            },
            992: {
                slidesPerView: Number(root.dataset.slidesPerView) || 2.8,
            }
        };

        new Swiper(el, options);
    });
}
